import React from "react";
import "./ViewCalculationRule.css";

const ViewCalculationRule = ({ rule, onClose }) => {
  const getFieldLabel = (code) => {
    switch (code) {
      case "QUALION_LEVEL":
        return "Qualion Level";
      case "DEPLOYABILITY_FLAG":
        return "Deployability Flag";
      case "CANDIDATE_MENTOR_CLASSIFICATION":
        return "Candidate/Mentor Classification";
      default:
        return code;
    }
  };

  const formatConcludedValue = (value) => {
    return value.replace(/_/g, " ");
  };

  return (
    <div className="view-calculation-modal-overlay" onClick={onClose}>
      <div
        className="view-calculation-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="view-calculation-modal-header">
          <div className="header-title-group">
            <h3>Calculation Rule Details</h3>
            <span className="header-subtitle">ID: #{rule.id}</span>
          </div>
          <button className="view-calculation-modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        {/* Body Content */}
        <div className="view-calculation-modal-body">
          
          {/* Section 1: General Information */}
          <div className="detail-section">
            <h4 className="section-title">General Information</h4>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Calculation Field</label>
                <span className="badge badge-blue">
                  {getFieldLabel(rule.calculation_field_code)}
                </span>
              </div>
              <div className="detail-item">
                <label>Scope</label>
                <span className="text-value">{rule.scope || "Tenant-wide"}</span>
              </div>
              <div className="detail-item full-width">
                <label>Rule Label</label>
                <span className="text-value emphasis">{rule.label}</span>
              </div>
            </div>
          </div>

          {/* Section 2: Logic & Evaluation */}
          <div className="detail-section">
            <h4 className="section-title">Logic & Evaluation</h4>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Sequence</label>
                <span className="text-value">{rule.sequence}</span>
              </div>
              <div className="detail-item">
                <label>Match Type</label>
                <div className="icon-text">
                  <i className={`fas ${rule.match_type === "ALL_CONDITIONS" ? "fa-layer-group" : "fa-code-branch"} icon-muted`}></i>
                  <span>
                    {rule.match_type === "ALL_CONDITIONS"
                      ? "All conditions must be met"
                      : "Any one condition is sufficient"}
                  </span>
                </div>
              </div>
              <div className="detail-item full-width">
                <label>Concluded Value</label>
                <div className={`concluded-box ${rule.concluded_value === 'NOT_DEPLOYABLE' ? 'warning' : 'success'}`}>
                   {formatConcludedValue(rule.concluded_value)}
                </div>
              </div>
            </div>
          </div>

          {/* Section 3: Governance */}
          <div className="detail-section">
            <h4 className="section-title">Governance</h4>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Status</label>
                <span
                  className={`status-pill ${
                    rule.is_active ? "active" : "inactive"
                  }`}
                >
                  <span className="status-dot"></span>
                  {rule.is_active ? "Active" : "Inactive"}
                </span>
              </div>
              <div className="detail-item">
                <label>Admin Approval</label>
                {rule.four_eyes ? (
                  <div className="approval-status required">
                    <i className="fas fa-check-circle"></i> Required
                  </div>
                ) : (
                  <div className="approval-status not-required">
                    <i className="fas fa-minus-circle"></i> Not Required
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="view-calculation-modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCalculationRule;